import {Injectable} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators} from '@angular/forms';
import {Person} from '../../types/person/person';

@Injectable()
export class FormHelperService {

  constructor(private _fb: UntypedFormBuilder) {
  }

  buildPersonForm() {
    return this._fb.group({
      title: ['', Validators.maxLength(50)],
      firstName: ['', [Validators.maxLength(255), Validators.required]],
      middleName: ['', Validators.maxLength(255)],
      lastName: ['', [Validators.maxLength(255), Validators.required]],
      honours: [''],
      suffix: ['', Validators.maxLength(50)],
      initials: ['', Validators.maxLength(50)],
      genderDescription: ['', Validators.maxLength(50)],
      comment: ['', Validators.maxLength(4096)],
      employee: [false],
      visibleInDirectory: [false],
      // appointments: this._fb.array([]),
      languages: [],
      language: [],
      gender: [''],
      organization: [],
      roles: [],
      country: [],
      region: ['', Validators.required],
      officialLanguage: ['', Validators.required],
      workingLanguage: ['', Validators.required],
      expertiseAreas: []
    });
  }

  initPersonForm(form: UntypedFormGroup, person: Person) {
    form.patchValue(person);
  }

  getFormValidationErrors(form: UntypedFormGroup) {
    const errors = [];

    Object.keys(form.controls).forEach(key => {
      const controlErrors: ValidationErrors = form.get(key).errors;

      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          errors.push(`Field: ${key}, Validation: ${keyError}`);
        });
      }
    });

    return errors.join(',');
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      if (control instanceof UntypedFormControl) {
        control.markAsDirty({onlySelf: true});
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  clearFormArray = (formArray: UntypedFormArray) => {
    formArray.controls = [];
    formArray.setValue([]);
  }

}
